import { render, staticRenderFns } from "./high-filtrate.vue?vue&type=template&id=56b11a6a&scoped=true"
import script from "./high-filtrate.vue?vue&type=script&lang=js"
export * from "./high-filtrate.vue?vue&type=script&lang=js"
import style0 from "./high-filtrate.vue?vue&type=style&index=0&id=56b11a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b11a6a",
  null
  
)

export default component.exports